export default __webpack_public_path__ + "static/media/ceo.81f30bbd.jpg";